import React from 'react'
import { ApexOptions } from 'apexcharts'
import { useTranslation } from 'react-i18next'
import ReactApexChart from 'react-apexcharts'

interface ReturnRateGraphProps {
  names: string[]
  returnRates: number[]
  refundRates: number[]
  labelRotation?: number
}

export const AreaReturnRateGraph: React.FC<ReturnRateGraphProps> = ({
  names,
  returnRates,
  refundRates,
  labelRotation = 0
}) => {
  const { t } = useTranslation()

  const options: ApexOptions = {
    chart: {
      type: 'area',
      height: 350,
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      }
    },
    colors: ['#85B8FF', '#0148a5'],
    stroke: {
      curve: 'straight'
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [0],
      formatter: (val: number) => `${val.toFixed(0)}%`
    },
    markers: {
      size: 5,
      hover: {
        size: 7
      },
      strokeWidth: 0
    },
    fill: {
      type: 'gradient',
      gradient: {
        opacityFrom: 0.6,
        opacityTo: 0.8
      }
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'center'
    },
    xaxis: {
      type: 'category',
      categories: names,
      labels: {
        style: {
          fontSize: '10px'
        },
        rotate: labelRotation,
        rotateAlways: labelRotation !== 0,
        hideOverlappingLabels: false
      }
    },
    yaxis: {
      labels: {
        formatter: (val: number) => `${val.toFixed(0)}%`
      },
      min: 0
    }
  }

  const series: ApexOptions['series'] = [
    {
      name: t('return_rate_table.return_rate'),
      data: returnRates
    },
    {
      name: t('return_rate_table.refund_rate'),
      data: refundRates
    }
  ]

  return (
    <div id="chart">
      <ReactApexChart
        options={options}
        type="area"
        series={series}
        height={350}
      />
    </div>
  )
}
